import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SalesComponent } from '@app/features/sales/sales/sales.component';
import { AddSaleComponent } from '@app/features/sales/add-sale/add-sale.component';
import { ViewSaleComponent } from '@app/features/sales/view-sale/view-sale.component';
import { EditSaleComponent } from '@app/features/sales/edit-sale/edit-sale.component';

const routes: Routes = [
  { path: '', component: SalesComponent },
  { path: 'add', component: AddSaleComponent },
  { path: ':saleId/edit', component: EditSaleComponent },
  { path: ':saleId', component: ViewSaleComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SalesRoutingModule { }
